import { inject, observer } from 'mobx-react';
import * as React from 'react';
import {
    Grid, GridColumn, Heading, Button
} from 'telia-front-react';
import TranslateStore from '@stores/TranslateStore';
import SsoStore from '@stores/SsoStore';
import config from '@config';

interface DisturbanceHeaderProps {
    translateStore?: TranslateStore;
    ssoStore?: SsoStore;
}

function DisturbanceHeader(props: DisturbanceHeaderProps) {
    const {
        translateStore: { translate },
        ssoStore: { customer, isDealer }
    } = props;
    return (
        <Grid align={['between-xs', 'middle-xs']}>
            <GridColumn width={['xs']}>
                <Heading element="h1" className="h2">{translate('general.employee.title')}</Heading>
            </GridColumn>
            { isDealer && (
                <GridColumn width={['xs']}>
                    <Grid>
                        { customer && (
                            <GridColumn width={['xs']}>
                                <Button
                                    text={translate('general.action.control.client')}
                                    iconRight="#arrow-right"
                                    type="employee"
                                    size="small"
                                    url={config.controlUrl}
                                    target="_blank"
                                />
                            </GridColumn>
                        )}
                        <GridColumn width={['xs']}>
                            <Button
                                text={translate('general.action.suspicion')}
                                iconRight="#arrow-right"
                                type="employee"
                                size="small"
                                url={config.suspicionUrl}
                                target="_blank"
                            />
                        </GridColumn>
                    </Grid>
                </GridColumn>
            )}
        </Grid>
    );
}

export default inject('ssoStore', 'translateStore')(observer(DisturbanceHeader));
